import { useCallback } from 'react';
import { LocalizeTextProps, TRANSLATION_NOT_FOUND, useLocalizeText } from './useLocalizeText';

export const useLocalizeTextOrNull = () => {
    const localizeText = useLocalizeText();

    return useCallback(
        ({ textKey, substitutes }: LocalizeTextProps) => {
            const localizedText = localizeText({ textKey, substitutes, fallbackToKey: false });
            return localizedText !== TRANSLATION_NOT_FOUND ? localizedText : null;
        },
        [localizeText]
    );
};
